'use client';

import React from 'react';
import { PageType, useGTM } from '@/features/Analytics';
import { PhoneAndBooking } from '@/features/PhoneAndBooking';
import { useDialogStore } from '@/features/Phones/model/store/phoneAndBooking';
import { usePhones } from '@/features/Phones/model/store/phones';
import { useDoctor } from '../model/store';
import type { IBookingDoctorData } from '@/entities/booking/model/types';
interface PhoneDialogWrapperProps {
  doctorId: number;
  medcenterId?: number | null;
  doctorImage: string;
  bookingData?: IBookingDoctorData[];
}
export const PhoneDialogWrapper: React.FC<PhoneDialogWrapperProps> = ({
  doctorId,
  medcenterId,
  doctorImage,
  bookingData
}) => {
  const {
    trackEvent
  } = useGTM(PageType.DOCTOR_PROFILE);
  const {
    isDialogOpen,
    closeDialog
  } = useDialogStore();
  const {
    phones
  } = usePhones();
  const {
    medcenterName
  } = useDoctor();
  const handlePhoneCall = (phoneNumber: {
    type: string;
    phone: string;
  }) => {
    trackEvent('call_thedoctor_popup', {
      numberType: phoneNumber.type,
      numberInfo: phoneNumber.phone,
      medcenterName: medcenterName
    });
  };
  const handleClosePhonesPreview = () => {
    trackEvent('close_popup_booking', {
      medcenterName: medcenterName
    });
  };
  const handleBookOnline = () => {
    trackEvent('click_popup_booking', {
      medcenterName: medcenterName
    });
  };
  return <PhoneAndBooking doctorImage={doctorImage} isOpen={isDialogOpen} onClose={closeDialog} phones={phones} doctorId={doctorId} medcenterId={medcenterId || null} bookingData={bookingData || null} onPhoneCallPreviewGtmEvent={handlePhoneCall} onClosePhonesPreviewGtmEvent={handleClosePhonesPreview} onBookOnlineGtmEvent={handleBookOnline} data-sentry-element="PhoneAndBooking" data-sentry-component="PhoneDialogWrapper" data-sentry-source-file="PhoneDialogWrapper.tsx" />;
};